<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <!-- <v-flex lg6 md6 sm12 v-if="userRole == 0">
                    <v-text-field v-model="staff.LevelName" label="Hạng thành viên" class="input-group--focused" disabled></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12 v-if="userRole == 0">
                    <h-currency-input v-model="staff.Point" :decimal="0" label="Doanh số tháng" class="input-group--focused" disabled></h-currency-input>
                </v-flex> -->
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="staff.Email" ref="username" label="Tài khoản" class="input-group--focused" disabled></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="staff.PhoneNumber" label="Điện thoại" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="staff.FullName" label="Họ tên" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="staff.Address" label="Địa chỉ" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 v-if="userRole > 0">
                    <v-select v-model="staff.RoleID" :items="role_list" item-text="name" item-value="value" label="Quyền hạn" disabled class="input-group--focused"></v-select>
                </v-flex>                
                <v-flex lg12 md12 sm12>
                    <v-checkbox v-model="change_pass" label="Đổi mật khẩu" class="input-group--focused"></v-checkbox>
                </v-flex> 
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="password" type="password" label="Mật khẩu mới" :disabled="!change_pass" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 v-if="specialFees && specialFees.length > 0">
                    <label class="h4 font-weight-bold">Phí đặc biệt</label>
                </v-flex>
                <v-flex lg12 md12 sm12 v-if="specialFees && specialFees.length > 0">
                    <v-data-table :headers="headers" :items="specialFees" :options.sync="pagination" :server-items-length="specialFees ? specialFees.length : 0" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item, index }">
                        <tr>
                        <td v-bind:style="{ 'color': text_color(item.ShippingMethod, shipping_methods)}">{{ item.ShippingMethod | display_value(shipping_methods) }}</td>
                        <td v-bind:style="{ 'color': text_color(item.ProductType, product_types)}">{{ item.ProductType | display_value(product_types) }}</td>
                        <td v-bind:style="{ 'color': text_color(item.CalcType, fee_types)}">{{ item.CalcType | display_value(fee_types) }}</td>
                        <td class="text-end">{{ item.Amount | currency }}</td>
                        </tr>
                    </template>
                    <template slot="no-data">
                        <span>
                        <p class="pt-2">Chưa cài đặt phí đặc biệt</p>
                        </span>
                    </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import { mapState } from "vuex";
import md5 from "md5";
import configs from "@/configs";
export default {
    data() {
        return {
            role_list: configs.ROLES,
            password: '',
            change_pass: false,
            shipping_methods: configs.SHIPPING_METHOD,
            product_types: configs.PRODUCT_TYPE,
            fee_types: configs.FEE_TYPES,
            pagination: {...configs.PAGINATION},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            headers: [
                {
                text: "Hình thức vận chuyển",
                value: "ShippingMethod",
                filterable: true,
                values: configs.SHIPPING_METHOD,
                dataType: configs.DATA_TYPE["Enum"]
                },
                {
                text: "Loại hàng",
                value: "ProductType",
                filterable: true,
                values: configs.PRODUCT_TYPE,
                dataType: configs.DATA_TYPE["Enum"]
                },
                {
                text: "Loại phí",
                value: "CalcType",
                filterable: true,
                values: configs.FEE_TYPES,
                dataType: configs.DATA_TYPE["Enum"]
                },
                {
                text: "Cước phí",
                value: "Amount",
                align: "end",
                filterable: true,
                dataType: configs.DATA_TYPE["Number"]
                }
            ]
        }
    },
    computed: {
        ...mapState({
            loading: state => state.staff.loading,
            staff: state => state.staff.selected,
            specialFees: state => state.specialFee.all.data,
        }),
        userRole() {
            return this.$store.state.authentication.user.roleid;
        },
        modifyId() {
            return this.$store.state.authentication.user.userid;
        }
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("staff/getDetail", this.modifyId);
                this.getListFee();
            }
            this.$nextTick(() => this.$refs.username.focus());
        },
        getListFee() {
            var param = {
            pagination: this.pagination,
            filter: [{
                column: "UID",
                value: this.modifyId,
                condition: "equal"
            }],
            quickFilter: []
            };
            this.$store.dispatch("specialFee/getList", param);
        },
        text_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        saveData() {
            if(this.change_pass) {
                this.staff.Password = md5(this.password)
            }
            this.$store.dispatch("staff/setDetail", {
                data: this.staff,
                id: this.staff.ID,
                notify: 'Đã cập nhật profile.'
            });
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.staff.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
